
<modal
  :title="title"
  size="full"
  :open="open"
  @close="closeModal"
>
  <form>
    <card-image-upload v-model="sale" />

    <text-area-input
      v-model="sale.title"
      label="Title"
    />

    <currency-input
      v-model="sale.price"
      label="Price"
    />

    <date-input
      v-model="sale.date"
      label="Date"
    />

    <select-input
      v-model="sale.platform"
      label="Platform"
      :options="platformOptions"
    />

    <select-input
      v-model="sale.listingType"
      label="Listing Type"
      :options="listingTypeOptions"
    />

    <text-input
      v-model.trim="sale.url"
      type="url"
      label="Sale URL"
    />

    <text-area-input
      v-model="sale.notes"
      label="Notes"
    />

    <checkbox
      v-model="sale.memberVerified"
      label="Member Verified"
    />
  </form>

  <template #footer>
    <align small-gap>
      <btn
        loading-text="Submitting"
        :loading="submitting"
        :disabled="disabled"
        @click="addOrEditSale"
      >
        Submit
      </btn>

      <btn kind="secondary" @click="closeModal">
        Cancel
      </btn>
    </align>
  </template>
</modal>
